import React from 'react';
import ImageLoader from '../images/ImageLoader';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

var RewardsProgramFeature = function RewardsProgramFeature(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;
  var Image = model.Image,
      Title = model.Title,
      Description = model.Description;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-rewards-program-feature"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-rewards-program-feature__image-container ".concat(props.index === 0 ? 'cb-rewards-program-feature__image-container--first-feature' : '')
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-feature__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-feature__title'
  }, Title.value), /*#__PURE__*/React.createElement("div", {
    className: 'cb-rewards-program-feature__copy'
  }, /*#__PURE__*/React.createElement(RichText, {
    field: Description,
    tag: 'span'
  }))));
};

export default RewardsProgramFeature;